import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Navigation, Scrollbar, Pagination, EffectFade } from 'swiper';
import { useLang } from '@/i18n';
const SecurityProtection = () => {
    const { t } = useLang('Delta3AirStation.SecurityProtection');
    const swiperRef = useRef<any>(null);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
    ];

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761564909716/security-bg-1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761564909716/security-bg-1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761650697869/security-bg-1-m.jpg',
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761564909892/security-bg-2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761564909892/security-bg-2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761650697686/security-bg-2-m.jpg',
            desc: t('item2_desc'),
        },
    ];

    const [activeItem, setActiveItem] = useState<any>(contentList[0]);

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentList[index]);
        swiperRef.current.slideToLoop(index);
        setActiveTabIndex(index);
    };

    const onSlideChange = ({ activeIndex, realIndex }: any) => {
        setActiveTabIndex(realIndex);
        setActiveItem(contentList[realIndex]);
    };
    return (
        <section className={`${styles.SecurityProtection} range2 GtmModuleData-section`} id="List-sence-B" data-section-id="SecurityProtection">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                <div className="security-swiper">
                    <Swiper
                        modules={[Navigation, Pagination, EffectFade]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        onSlideChange={onSlideChange}
                        loop={true}
                        effect={'fade'}
                        speed={800}
                        pagination
                        centeredSlides={true}
                        spaceBetween={16}
                        slidesPerView={'auto'}
                    >
                        {contentList.map((item, index) => (
                            <SwiperSlide key={index} className="swiper-slide">
                                <EcoImg className="swiper-img" pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className={`content-tab`}>
                    <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} activeIndex={activeTabIndex} />
                </div>
                <div className="content-desc">{activeItem.desc}</div>
            </div>
        </section>
    );
};

export default SecurityProtection;
